import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as MinusIcon } from "../../assets/icons/minus.svg";

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [childHeight, setChildHeight] = useState(0);

  const handleResize = () => {
    setChildHeight(ref.current.offsetHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="py-6">
      <button
        className={`flex w-full items-center justify-between space-x-3 transition-all text-xl lg:text-[27px] 
          text-white header 
          ${open ? "rounded-t-xl" : "rounded-xl"}`}
        onClick={() => setOpen(!open)}
      >
        <div className="text-left">{title}</div>
        <div className="border border-navy-light rounded-full h-12 w-12 flex items-center justify-center">
          <div className="relative">
            <MinusIcon />
            <MinusIcon
              className={`absolute transition-all top-0 left-0
              ${open ? "" : "rotate-90"}`}
            />
          </div>
        </div>
      </button>
      <div
        ref={ref}
        className={`transition-all duration-200 rounded-b-xl overflow-hidden text-gray-450 text-lg
        ${open ? `h-[${childHeight}px] pt-4` : "h-0 pt-0"}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
